import { AloftPrice } from '@aloft/toolkit-shared';

import { createPriceSelector } from '../utils/createPriceSelector.ts';
import { selectCarportCost, selectZipOnlyCarportCost } from './selectCarportCost.ts';
import {
  selectDetachedGarageCost,
  selectZipOnlyDetachedGarageCost,
} from './selectDetachedGarageCost.ts';
import { selectGarageCost, selectZipOnlyGarageCost } from './selectGarageCost.ts';

const calculateGarageCarportCost = (
  carportCost?: AloftPrice,
  detachedGarageCost?: AloftPrice,
  garageCost?: AloftPrice,
) => {
  if (!carportCost && !detachedGarageCost && !garageCost) return undefined;

  const carport = carportCost ?? AloftPrice.zero;
  const detachedGarage = detachedGarageCost ?? AloftPrice.zero;
  const garage = garageCost ?? AloftPrice.zero;

  return carport.add(detachedGarage).add(garage);
};

export const selectGarageCarportCost = createPriceSelector(
  [selectCarportCost, selectDetachedGarageCost, selectGarageCost],
  calculateGarageCarportCost,
);

export const selectZipOnlyGarageCarportCost = createPriceSelector(
  [selectZipOnlyCarportCost, selectZipOnlyDetachedGarageCost, selectZipOnlyGarageCost],
  calculateGarageCarportCost,
);
